module.exports = __webpack_public_path__ + "img/arrow_left_square.9b1ce6f2.svg";